import FlightLandIcon from '@mui/icons-material/FlightLand';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import SailingIcon from '@mui/icons-material/Sailing';

export const serviceList: any = [
    {
        title: "Sea Freight Forwarding",
        body: 'Navigating the vast oceans of global commerce requires expertise, precision, and a reliable partner. Our Sea Freight Forwarding services ensure cost-effective, secure, and timely transportation of goods worldwide. Whether it’s full container loads (FCL) or less-than-container loads (LCL), we leverage our extensive network of shipping lines and strategic partnerships to optimize routes and minimize transit times.',
        points: [
            'Reliable global shipping network',
            'Flexible freight solutions (FCL & LCL)',
            'End-to-end cargo tracking & documentation',
            'Cost-effective logistics planning',
        ],
        icon: <SailingIcon className='iconSize' />,
        image: require('../assets/images/services/service1.jpg')
    },
    {
        title: "Custom Clearing & Forwarding",
        body: 'Customs regulations can be complex, but with our Custom Clearing & Forwarding expertise, we simplify the process for you. Our experienced team ensures hassle-free clearance of shipments, minimizing delays and avoiding compliance pitfalls. We handle all necessary documentation, duties, and taxes to keep your supply chain moving smoothly.',
        points: [
            'Efficient customs clearance & compliance',
            'Duty & tax calculations for cost transparency',
            'Smooth coordination with regulatory authorities',
            'End-to-end logistics support',
        ],
        icon: <FlightLandIcon className='iconSize' />,
        image: require('../assets/images/services/service2.jpg')
    },
    {
        title: "Consultant Services",
        body: "In today’s fast-paced business world, expert guidance makes all the difference. Our Consultancy Services provide insights and strategic solutions tailored to your business needs. Whether you're optimizing supply chain processes, exploring new markets, or improving operational efficiency, we offer data-driven advice to help you make informed decisions.",
        points: [
            'Supply chain & logistics optimization',
            'Trade regulations & compliance advisory',
            'Market analysis & business expansion strategies',
            'Tailored solutions for efficiency & cost savings',
        ],
        icon: <Diversity3Icon className='iconSize' />,
        image: require('../assets/images/services/service3.jpg')
    },
    // {
    //     title: "Custom Clearing & Forwarding",
    //     body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente eligendi odio aliquam hic accusantium consequuntur ipsam odit laborum! Doloribus quas vitae nemo aut modi nam nesciunt porro in? Tempore, aspernatur.',
    //     image: '/src/assets/images/brk2.png'
    // },
    // {
    //     title: "Custom Clearing & Forwarding",
    //     body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente eligendi odio aliquam hic accusantium consequuntur ipsam odit laborum! Doloribus quas vitae nemo aut modi nam nesciunt porro in? Tempore, aspernatur.',
    //     image: '/src/assets/images/brk2.png'
    // },
    // {

    //     title: "Custom Clearing & Forwarding",
    //     body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente eligendi odio aliquam hic accusantium consequuntur ipsam odit laborum! Doloribus quas vitae nemo aut modi nam nesciunt porro in? Tempore, aspernatur.',
    //     image: '/src/assets/images/brk2.png'
    // },
]